import Axios from "axios";
import React, { useState, useEffect } from "react";
import constants from "../../constants";

export function Invoice(props) {
  const [paymentRequest, setPaymentRequest] = useState(null);

  function testWhite(x) {
    var white = new RegExp(/^\s$/);
    return white.test(x.charAt(0));
  }

  function wordWrap(str, maxWidth) {
    var newLineStr = "\n";
    var done = false;
    var res = "";
    while (str.length > maxWidth) {
      let found = false;
      // Inserts new line at first whitespace of the line
      for (let i = maxWidth - 1; i >= 0; i--) {
        if (testWhite(str.charAt(i))) {
          res = res + [str.slice(0, i), newLineStr].join("");
          str = str.slice(i + 1);
          found = true;
          break;
        }
      }
      // Inserts new line at maxWidth position, the word is too long to wrap
      if (!found) {
        res += [str.slice(0, maxWidth), newLineStr].join("");
        str = str.slice(maxWidth);
      }
    }

    return res + str;
  }
  function generateHeaderDotted(title, size, dot = "-") {
    let dottedHeader = `\n${dot.repeat(size)} ${title} ${dot.repeat(size)} \n`;
    return dottedHeader;
  }

  useEffect(() => {
    let id = props.params.id;

    let url =
      constants().URL_SERVICE +
      "establishment/paymentrequest/payment_request/" +
      "?paymentId=" +
      id;

    Axios.get(url, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        setPaymentRequest(response.data);
        setTimeout(() => {
          window.print();
        }, 500);
      })
      .catch((error) => this.setState({ error: true }));
  }, []);

  function renderCupom() {
    debugger;
    let cupom = "";

    cupom = `${generateHeaderDotted("DELIVERY", 31)}
Fornecedor: ${paymentRequest.establishment.name}
Contato: ${paymentRequest.establishment.contato} 
Pedido n: ${paymentRequest.id} 
Data: ${paymentRequest.date} 
Hora: ${paymentRequest.time} 
${generateHeaderDotted("DESCRIÇÃO DO PEDIDO ", 25)}
Pedido n: ${paymentRequest.id} 
Descrição: ${paymentRequest.description}
${generateHeaderDotted("INFO ENTREGA", 29)}
Nome: ${paymentRequest.client.name}
Telefone: ${paymentRequest.client.phone} 
Endereço retirada: ${wordWrap(
      paymentRequest.shipping.initial_address_delivery,
      50
    )} 
Endereço entrega: ${wordWrap(
      paymentRequest.shipping.final_address_delivery,
      50
    )}  
${generateHeaderDotted("OBSERVAÇÕES ", 29)}
Valor do pedido: ${paymentRequest.price_brl} 
`
if(paymentRequest.shipping.shipping_brl){
  cupom = cupom + `Valor frete: ${paymentRequest.shipping.shipping_brl}`
}
if(paymentRequest.shipping.return_tax_brl){
  cupom = cupom + `\nValor retorno: ${paymentRequest.shipping.return_tax_brl}`
}

cupom = cupom + `
${"_".repeat(72)}
Valor total: ${paymentRequest.shipping.total_price_brl}  
${generateHeaderDotted("INFO PAGAMENTO", 28)}
Canal: Allfast
Pagamento: Cartão de crédito
Valor pagamento:${paymentRequest.shipping.total_price_brl}  
${generateHeaderDotted("INFO. PARA ENTREGADOR ", 24)}

`;

    if (paymentRequest.shipping.return_tax) {
      cupom =
        cupom +
        "******************************* RETORNAR *******************************";
    }
    return cupom;
  }


  function renderCupomWithoutShipping() {
    let cupom = "";

    cupom = `${generateHeaderDotted("DELIVERY", 31)}
Fornecedor: ${paymentRequest.establishment.name}
Contato: ${paymentRequest.establishment.contato} 
Pedido n: ${paymentRequest.id} 
Data: ${paymentRequest.date} 
Hora: ${paymentRequest.time} 
${generateHeaderDotted("DESCRIÇÃO DO PEDIDO ", 25)}
Pedido n: ${paymentRequest.id} 
Descrição: ${paymentRequest.description}
${generateHeaderDotted("INFO ENTREGA", 29)}
Nome: ${paymentRequest.client.name}
Telefone: ${paymentRequest.client.phone} 
${generateHeaderDotted("OBSERVAÇÕES ", 29)}
Valor do pedido: ${paymentRequest.shipping.total_price_brl} 
${"_".repeat(72)}
Valor total: ${paymentRequest.shipping.total_price_brl}  
${generateHeaderDotted("INFO PAGAMENTO", 28)}
Canal: Allfast
Pagamento: Cartão de crédito
Valor pagamento:${paymentRequest.shipping.total_price_brl}  
`;

    return cupom;
  }
  return (
    paymentRequest && (
      <pre style={{ "margin-top": "1px" }}>
        {paymentRequest.shipping.initial_address_delivery
          ? renderCupom()
          : renderCupomWithoutShipping()}
      </pre>
    )
  );
}



// WEBPACK FOOTER //
// ./src/views/Invoice/index.js